<template>
  <base-section id="features-detailed">
    <v-container>
      <div style="padding-left: 12px; padding-right: 12px; margin-bottom: 24px">
        <v-row>
          <div style="width: 100%">
            <h1>{{ $t("How to Install Media Hoarder") }}</h1>
          </div>
          <!-- TODO: Platform Selection -->
          <div style="width: 100%">
            <v-select
              v-model="selectedPlatform"
              v-bind:items="platforms"
              v-bind:label="$t('Select your platform')"
              v-on:change="onPlatformChanged"
            ></v-select>
          </div>

          <div v-if="selectedPlatform === 'MacOS'">
            <div style="width: 100%">
              <p>
                {{
                  $t(
                    "Watch the video below for a step-by-step MacOS installation_"
                  )
                }}
              </p>
            </div>
            <div style="width: 100%">
              <iframe
                width="560"
                height="315"
                src="https://www.youtube-nocookie.com/embed/2G4pqhONptA"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
          </div>
          <div v-else-if="selectedPlatform === 'Linux'">
            <div style="width: 100%">
              <p>
                {{
                  $t(
                    "Watch the video below for a step-by-step Linux installation_"
                  )
                }}
              </p>
            </div>
            <div style="width: 100%">
              <iframe
                width="560"
                height="315"
                src="https://www.youtube-nocookie.com/embed/GjL-iLl9uLU"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
          </div>
          <div v-else>
            <div style="width: 100%">
              <p>
                {{
                  $t(
                    "Watch the video below for a step-by-step Windows installation_"
                  )
                }}
              </p>
            </div>
            <div style="width: 100%">
              <iframe
                width="560"
                height="315"
                src="https://www.youtube-nocookie.com/embed/JohmR24tqYo"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
          </div>

          <div style="width: 100%; margin-top: 16px">
            <h1>{{ $t("First Steps") }}</h1>
            <p>
              {{
                $t(
                  "After installation the first steps necessary to scan your collection are platform independent_"
                )
              }}
            </p>
            <p>{{ $t("Watch the video below showcasing the first steps_") }}</p>
            <div style="width: 100%">
              <iframe
                width="560"
                height="315"
                src="https://www.youtube-nocookie.com/embed/B3Q2Gcg8mTE"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
          </div>
        </v-row>
      </div>
    </v-container>
  </base-section>
</template>

<script>
export default {
  name: "SectionGettingStarted",

  data: () => ({
    selectedPlatform: null,
    platforms: ["Windows", "Linux", "MacOS"]
  }),

  computed: {},

  methods: {
    userPlatform() {
      const platform = navigator.platform;
      const macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"];
      const windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"];

      if (macosPlatforms.indexOf(platform) !== -1) {
        return "MacOS";
      } else if (windowsPlatforms.indexOf(platform) !== -1) {
        return "Windows";
      } else if (/Linux/.test(platform)) {
        return "Linux";
      }

      return null;
    }
  },

  /**
   * Lifecycle Hooks
   */
  created() {
    this.selectedPlatform = this.userPlatform();
  }
};
</script>
